<template>
  <div>
    <br-topbar v-if="show"></br-topbar>
    <BrMask v-if="show_mask"></BrMask>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <br-main-container v-if="show"></br-main-container>
        </div>
        <div class="col-12">
          <br-footer></br-footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BrTopbar from "@/components/ReadingExperience/TopBar";
import { mapMutations, mapState } from "vuex";
import BrFooter from "@/components/ReadingExperience/common/BrFooter";
import BrMainContainer from "@/components/ReadingExperience/book/BrMainContainer";
import BrMask from "@/components/BrMask";

export default {
  name: "ReadingExperience",
  props: ["book_id"],
  computed: {
    ...mapState(["teacherData", "dataUrl", "readingExperience"]),
    show_mask: function() {
      return (
        this.readingExperience.index ||
        this.readingExperience.dict ||
        this.readingExperience.question
      );
    },
  },
  components: {
    BrTopbar,
    BrFooter,
    BrMainContainer,
    BrMask,
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    ...mapMutations([
      "setBookData",
      "fillChapterList",
      "initBook",
      "setQuestionData",
      "resetReadingExperience",
    ]),
    async getBookData() {
      try {
        let data = null;
        data = await this.axios.get(
          this.dataUrl + `/book/getBookById?bookId=${this.book_id}`
        );
        this.setBookData(data.data.content);

        data = await this.axios.post(
          this.dataUrl +
            `/bookChapter/getChaptersListByBook?bookId=${this.book_id}`
        );
        this.fillChapterList(data.data.content);
        this.initBook();

        await this.axios
          .post(
            this.dataUrl +
              `/bookAssessmentItem/getItemsByBook?bookId=${this.book_id}`
          )
          .then(response => {
            this.setQuestionData(response.data.content);
          });

        this.show = true;
      } catch {
        // console.error(e);
      }
    },
  },
  mounted() {
    this.resetReadingExperience();
    this.getBookData();
  },
};
</script>
